import React from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined'
import { alpha } from '@mui/material/styles'

import MobileEmptyStateCard from '../../components/MobileEmptyStateCard'
import { RefundMobileCard } from '../mobile'
import { getFormattedRefundDate, openRefundInNewTab } from '../helpers/refundIndexFilters'

export default function RefundIndexMobileList({
  data,
  expandedRefundUuid,
  onToggleExpand
}) {
  if (!data || data.length === 0) {
    return (
      <Box sx={{ mt: 1 }}>
        <MobileEmptyStateCard
          icon={<AssignmentReturnOutlinedIcon fontSize="small" />}
          title="No hay devoluciones disponibles"
          description="Cuando existan devoluciones para los filtros seleccionados, aparecerán aquí con su detalle."
        />
      </Box>
    )
  }

  return (
    <Box
      sx={(theme) => ({
        mt: 1,
        mb: 0.5,
        py: 2,
        px: { xs: 0.5, sm: 1 },
        mx: { xs: -0.5, sm: -1 },
        borderRadius: 2,
        bgcolor: alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.06 : 0.04)
      })}
    >
      <Grid container spacing={2.5}>
        {data.map((model, index) => (
          <RefundMobileCard
            key={model.uuid || index}
            model={model}
            getFormattedDate={getFormattedRefundDate}
            openRefundInNewTab={openRefundInNewTab}
            expanded={expandedRefundUuid === model.uuid}
            onToggleExpand={() => onToggleExpand(model.uuid)}
          />
        ))}
      </Grid>
    </Box>
  )
}
